import { I18nKeys } from '../models/i18n.model';
import { ScheduleOption, ScheduleOptionValueEnum } from '../models/schedule-option.model';

export const SCHEDULE_OPTIONS: ScheduleOption[] = [
	{
		value: ScheduleOptionValueEnum.IMMEDIATE,
		translationKey: I18nKeys.CALLBACK_TIME_ASAP,
	},
	{
		value: ScheduleOptionValueEnum.SPECIFIC_DATE_TIME,
		translationKey: I18nKeys.CALLBACK_SCHEDULE,
	},
];

export const END_HOUR_OFFSET_IN_MINUTES = 0; // TODO: check if offset is needed and use correct value
